<template>
<div id="Home" :class="$style.home">
  <div :class="$style.box">
    <img @dragstart.prevent src="../assets/img/home/banner.png"
      style="width:100%;height: 656x;"/>
  </div>
  <div :class="$style.box" style="height:510px;background: #F2F4F8;">
    <div style="width:1200px;height:100%;margin:0 auto;position: relative;">
      <div style="position:absolute;top:67px;left:10px;width: 385px;
        height: 46px;font-size: 48px;font-family: Arial;font-weight: bold;color: #EBEBEB;
        line-height: 20px; opacity: 0.67;">
        Company Profile
      </div>
      <div style="position:absolute;top:82px;left:12px;width:130px;
        height: 28px;font-size: 30px;font-family: Microsoft YaHei;font-weight: bold;
        color: #333333;line-height: 30px;">
        公司简介
      </div>
      <div style="position:absolute;top:126px;left:10px;width:116px;height:3px;
        background: #005BAC;">
      </div>
      <div style="position:absolute;top:165px;left:12px;width:623px;height:262px;">
        <img @dragstart.prevent  src="../assets/img/home/1.png"
          style="width:623px;height:262px;"/>
      </div>
      <div style="position:absolute;top:192px;left:610px;width:651px;height:218px;
        background: #FFFFFF;">
        <div style="width: 580px;height: 74px;font-size: 14px;font-family: Microsoft YaHei;
          font-weight: 400;color: #333333;line-height: 30px;margin-top: 43px;margin-left: 36px;">
          <span style="margin-left: 30px;">杭州鼎控专业从事工业软件的研发，聚焦生产、能源、设备、环境、安全等应用软件</span><br/>
          业务。旨在开发一款轻量数字化工具软件，让每个工厂都能快速、便捷、低成本的实现全厂<br/>
          数字化管控。为企业构建持续降本增效的管理体系夯实基础。
        </div>
        <div style="width: 78px;height: 30px;background: #004F95;border-radius: 3px;
          margin-top: 45px;margin-left: 500px;" @click="toAbout">
          <span style="width: 61px;height: 15px;font-size: 14px;font-family: Microsoft YaHei;
            font-weight: 400;color: #FFFFFF;line-height: 30px;margin-left: 5px;cursor: pointer;">
            了解更多>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div :class="$style.box" style="height:853px;background: #000;">
    <div style="width:1122px;height:100%;margin:0 auto;position: relative;">
      <div :class="$style.wentiSpan" style="position:absolute;top:52px;left:420px;">
        solved problem
      </div>
      <div :class="$style.wentiSpan1" style="position:absolute;top:67px;left:525px;">
        解决的问题
      </div>
      <div :class="$style.wentiSpan1" style="position:absolute;top:111px;left:539px;
        width: 116px;height: 3px;background: #005BAC;"></div>
      <div :class="$style.mp4">
        <video-player class="video-player vjs-custom-skin" ref="videoPlayer"
          :playsinline="true" :options="playerOptions"></video-player>
      </div>
      <div :class="$style.mp"></div>
      <!--
      <div :class="$style.img1">
        <div style="width:100%;height:100%;position: relative;">
          <div :class="$style.info1">
            <div :class="mouseIndex == 1 ? $style.div2 : index == 1 && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:10px 50px 20px 5px;">
              实时掌握各厂务系统设备的运行参数、报警信息、事件信息和健康状况
            </div>
          </div>
          <div :class="$style.info2">
            <div :class="mouseIndex == 2 ? $style.div2 : index == 2  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:10px 70px 20px 5px;">
              全厂能源供应、能源统计、能源对标、能源预警、分摊结算
            </div>
          </div>
          <div :class="$style.info3">
            <div :class="mouseIndex == 3 ? $style.div2 : index == 3  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:10px 50px 20px 5px;">
              设备维修管理、设备维护保养管理、设备点检管理,形成设备生命周期档案
            </div>
          </div>
          <div :class="$style.info4">
            <div :class="mouseIndex == 4 ? $style.div2 : index == 4  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:10px 50px 20px 5px;">
              能源、原料、设备、产品等全流程多维护数据图形化看板呈现，实时看管监控
            </div>
          </div>
          <div :class="$style.info5">
            <div :class="mouseIndex == 5 ? $style.div2 : index == 5  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:10px 10px 10px 10px;">
              风险全流程管理、包括风险辨识、风险分级、风险管控、两单三卡等，建立完善的安全生产规章制度
            </div>
          </div>
          <div  :class="$style.info6">
            <div :class="mouseIndex == 6 ? $style.div2 : index == 6  && mouseIndex == 0 ?
            $style.div : $style.div1" style="margin:10px 10px 10px 10px;">
              危废鉴别、生产、入库出库全流程管理
            </div>
          </div>
          <div :class="$style.info7">
            <div :class="mouseIndex == 7 ? $style.div2 : index == 7  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:15px 5px 10px 5px;">
              废水、废气、废声、废渣的排放处理，包括监测计划、监测报告和监测预警信息
            </div>
          </div>
          <div :class="$style.info8">
            <div :class="mouseIndex == 8 ? $style.div2 : index == 8  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:15px 5px 10px 5px;">
              盘点和规划杂乱的数据资源，形成主题明确、服务完善、权责清晰的数据资产信息。
            </div>
          </div>
          <div :class="$style.info9">
            <div :class="mouseIndex == 9 ? $style.div2 : index == 9  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:0px 5px 0px 60px;">
              产品产量、单产品能耗、单产品原料消耗、万元产值综合能耗等多类KPI指标考核
            </div>
          </div>
          <div :class="$style.info10">
            <div :class="mouseIndex == 10 ? $style.div2 : index == 10  && mouseIndex == 0 ?
            $style.div : $style.div1"
            style="margin:0px 5px 0px 70px;">
              通过自定义表单定义各产品质检表单，根据质检情况人为录入产品质检数据，为产品追朔提供依据
            </div>
          </div>
          <div :class="$style.mask1" @mouseover="vdivmouseover('1')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask2" @mouseover="vdivmouseover('2')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask3" @mouseover="vdivmouseover('3')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask4" @mouseover="vdivmouseover('4')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask5" @mouseover="vdivmouseover('5')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask6" @mouseover="vdivmouseover('6')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask7" @mouseover="vdivmouseover('7')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask8" @mouseover="vdivmouseover('8')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask9" @mouseover="vdivmouseover('9')" @mouseout="vdivmouseout"></div>
          <div :class="$style.mask10" @mouseover="vdivmouseover('10')" @mouseout="vdivmouseout">
          </div>
        </div>
      </div>-->
    </div>
  </div>
  <div :class="$style.box" style="height:769px;background: #FFF;">
    <div style="width:1122px;height:100%;margin:0 auto;position: relative;">
      <div style="position:absolute;top:76px;left:434px;width: 385px;
        height: 46px;font-size: 48px;font-family: Arial;font-weight: bold;color: #EBEBEB;
        line-height: 20px; opacity: 0.67;">
        Product value
      </div>
      <div style="position:absolute;top:90px;left:537px;width:130px;
        height: 28px;font-size: 30px;font-family: Microsoft YaHei;font-weight: bold;
        color: #333333;line-height: 30px;">
        产品价值
      </div>
      <div style="position:absolute;top:134px;left:539px;width:116px;height:3px;
        background: #005BAC;">
      </div>
      <div style="position:absolute;top:211px;left:0px;width:288px;height:477px;">
        <div :class="$style.p1_1">
          <img @dragstart.prevent src="../assets/img/home/组 22.png"
            style="width:130px;height:148px;"/>
          <div :class="$style.p1_2">
            100%
          </div>
        </div>
        <div  :class="$style.p1_3">
          提升设备故障预测性和点巡检精准度
        </div>
        <div style="width:21px;height:1px;margin: 14px auto;background: #333333;"></div>
        <div :class="$style.p1_4">
          长时间积累设备维修数据，利用大数据分<br/>析技术，提前预防性检查，精准化点巡检<br/>，有效提升生产保障水平和降低维修成本
        </div>
        <div :class="$style.p1_5">
          <div :class="$style.p1_6">
            企业全要素对标
          </div>
          <div :class="$style.p1_7">
          </div>
          <div  :class="$style.p1_8">
            企业生产全要素可视化对标，致力于实<br/>现行业先进生产水平，提升企业生产竞<br/>争力
          </div>
        </div>
      </div>
      <div style="position:absolute;top:211px;left:303px;width:288px;height:477px;">
        <div :class="$style.p1_1">
          <img @dragstart.prevent src="../assets/img/home/组 16 拷贝.png"
            style="width:130px;height:148px;"/>
          <div :class="$style.p1_2">
            36倍
          </div>
        </div>
        <div :class="$style.p1_3" style="width: 136px;">
          提高能耗分析效率
        </div>
        <div style="width:21px;height:1px;margin: 14px auto;background: #333333;"></div>
        <div :class="$style.p1_4">
          能耗异常原因分析效率得以提高，由平均<br/>3小时，缩短至平均5分钟
        </div>
        <div :class="$style.p1_5">
          <div :class="$style.p1_6" style="width:136px;">
            形成有效数字资产
          </div>
          <div :class="$style.p1_7">
          </div>
          <div  :class="$style.p1_8">
            盘点和规划杂乱的数据资源，构建主题<br/>明确、服务完善、权责清晰的数据资产<br/>管理，助力以数据驱动产生的业务价值
          </div>
        </div>
      </div>
      <div style="position:absolute;top:211px;left:606px;width:288px;height:477px;">
        <div :class="$style.p1_1">
          <img @dragstart.prevent src="../assets/img/home/组 17 拷贝.png"
            style="width:130px;height:148px;"/>
          <div :class="$style.p1_2">
            100%
          </div>
        </div>
        <div :class="$style.p1_3" style="width: 180px;">
          工厂级数字化作业覆盖率
        </div>
        <div style="width:21px;height:1px;margin: 14px auto;background: #333333;"></div>
        <div :class="$style.p1_4">
          工厂、车间级的作业实现电子化，数字<br/>化。任务可视，过程可溯，结果可控
        </div>
        <div :class="$style.p1_5">
          <div :class="$style.p1_6" style="width:136px;">
            完整的生产批记录
          </div>
          <div :class="$style.p1_7">
          </div>
          <div  :class="$style.p1_8">
            产品批记录一键生成，解放生产工人纸质<br/>记录生产批次过程数据工作，减轻生产工<br/>人工作量
          </div>
        </div>
      </div>
      <div style="position:absolute;top:211px;left:912px;width:288px;height:477px;">
        <div :class="$style.p1_1">
          <img @dragstart.prevent src="../assets/img/home/组 17 拷贝 2.png"
            style="width:130px;height:148px;"/>
          <div :class="$style.p1_2">
            100%
          </div>
        </div>
        <div :class="$style.p1_3" style="width: 150px;">
          安全合规，环保合规
        </div>
        <div style="width:21px;height:1px;margin: 14px auto;background: #333333;"></div>
        <div :class="$style.p1_4">
          安全生产、环境保护全流程合规性研判，<br/>帮助企业实现合规可视化
        </div>
        <div :class="$style.p1_5">
          <div :class="$style.p1_6" style="width:96px;">
            专题报告直送
          </div>
          <div :class="$style.p1_7">
          </div>
          <div :class="$style.p1_8">
            通过对全要素数据的多维分析，以专题<br/>形式生成可视化报告，并且实时精准投<br/>送到相关人员
          </div>
        </div>
      </div>
    </div>
  </div>
  <div :class="$style.box" style="height:853px;background: #111217;opacity: 0.94;">
    <div style="width:1193px;height:100%;margin:0 auto;position: relative;">
      <div :class="$style.wentiSpan" style="position:absolute;top:52px;left:370px;width:477px;">
      Product Advantages
    </div>
    <div :class="$style.wentiSpan1" style="position:absolute;top:67px;left:545px;;width:137px;">
      产品优势
    </div>
    <div :class="$style.wentiSpan1" style="position:absolute;top:111px;left:539px;
      width: 116px;height: 3px;background: #005BAC;"></div>
      <div style="position:absolute;top:179px;left:0px;width:1193px;height:611px;
        background: #000;border-radius: 10px;position: absolute;">
        <div style="width:87px;height:99px;top:88px;left:132px;position: absolute;
        ">
          <img @dragstart.prevent  src="../assets/img/home/组 18.png"
            style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:209px;left:152px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          接地气
        </div>
        <div style="width:185px;height:15px;top:240px;left:86px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          直接落地到车间的信息化系统
        </div>
        <div style="width:87px;height:99px;top:88px;left:406px;position: absolute;
        ">
          <img @dragstart.prevent src="../assets/img/home/组 18-1.png"
          style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:209px;left:426px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          能落地
        </div>
        <div style="width:210px;height:15px;top:240px;left:347px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          面向自控工程师的信息化管理软件
        </div>
        <div style="width:87px;height:99px;top:88px;left:692px;position: absolute;">
          <img @dragstart.prevent src="../assets/img/home/组 18-2.png"
          style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:209px;left:712px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          低代码
        </div>
        <div style="width:128px;height:15px;top:240px;left:671px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          操作简单，灵活配置
        </div>
        <div style="width:87px;height:99px;top:88px;left:953px;position: absolute;">
          <img @dragstart.prevent src="../assets/img/home/组 18-3.png"
          style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:209px;left:973px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          功能全
        </div>
        <div style="width:220px;height:15px;top:240px;left:895px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          集成丰富的可视化工具和工业应用
        </div>
        <div style="width:87px;height:99px;top:333px;left:132px;position: absolute;">
          <img @dragstart.prevent src="../assets/img/home/组 18-4.png"
          style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:456px;left:152px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          易使用
        </div>
        <div style="width:196px;height:15px;top:486px;left:86px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          符合工业应用习惯的信息化系统
        </div>
        <div style="width:87px;height:99px;top:333px;left:406px;position: absolute;">
          <img @dragstart.prevent src="../assets/img/home/组 18-5.png"
          style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:455px;left:426px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          可闭环
        </div>
        <div style="width:200px;height:15px;top:486px;left:366px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          紧密连接设备的信息化系统
        </div>
        <div style="width:87px;height:99px;top:333px;left:692px;position: absolute;">
          <img @dragstart.prevent src="../assets/img/home/组 18-6.png"
          style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:456px;left:712px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          交付快
        </div>
        <div style="width:128px;height:15px;top:486px;left:685px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          投运周期短1-4周
        </div>
        <div style="width:87px;height:99px;top:333px;left:953px;position: absolute;">
          <img  @dragstart.prevent src="../assets/img/home/组 18-7.png"
          style="width:87px;height:99px;"/>
        </div>
        <div style="width:49px;height:16px;top:456px;left:973px;position: absolute;font-size: 16px;
          font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 24px;">
          低成本
        </div>
        <div style="width:220px;height:15px;top:486px;left:904px;position: absolute;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #969AA1;line-height: 24px;">
          按需选择，每个企业都用得起
        </div>
      </div>
    </div>
  </div>
  <div :class="$style.box" style="height:699px;background: #FFF;">
    <div style="width:1192px;height:100%;margin:0 auto;position: relative;">
      <div style="position:absolute;top:82px;left:385px;width: 420px;
        height: 46px;font-size: 48px;font-family: Arial;font-weight: bold;color: #EBEBEB;
        line-height: 20px; opacity: 0.67;">
        Cooperate Partner
      </div>
      <div style="position:absolute;top:97px;left:537px;width:130px;
        height: 28px;font-size: 30px;font-family: Microsoft YaHei;font-weight: bold;
        color: #333333;line-height: 30px;">
        合作伙伴
      </div>
      <div style="position:absolute;top:134px;left:539px;width:116px;height:3px;
        background: #005BAC;">
      </div>
      <div style="position:absolute;top:160px;left:0px;width:1222px;height:420px;">
        <div class="fill">
          <template>
            <el-carousel :interval="5000" arrow="always" height="420px">
              <el-carousel-item v-for="(item, i) in homeDatas" :key="i">
                <div style="margin:10px;background:green;">
                  <div v-for="imgsrc in item.data" :key="imgsrc" style="width: 238px;height: 130px;
                  float: left;border: 1px solid #e6e6e6;border-collapse:collapse;"
                  :style="{backgroundImage: 'url(' + require('../assets/img/home/合作伙伴/'
                  + imgsrc ) + ')'}"></div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </template>
        </div>
      </div>
      <div style="position:absolute;top:580px;left:136px;width:961px;height:65px;">
        <img  @dragstart.prevent src="../assets/img/home/图层 23.png"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  homeData
} from '../assets/js/home';

export default {
  name: 'Home',
  data() {
    return {
      homeDatas: [],
      timer: null,
      index: 0,
      mouseIndex: 0,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, // 如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: null, // 路径
          type: 'video/mp4' // 类型
        }],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          show: false,
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false // 全屏按钮
        },
        controls: false,
        subtitle: {
          url: 'http://www.baidu.com',
          fontSize: '20px',
          bottom: '50%',
        },
      }
    };
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  created() {
    this.playerOptions.sources[0].src = require('../assets/img/home/eDVS3_7.mp4');
    this.homeDatas = homeData;
    // this.timer = setInterval(() => {
    //  this.index++;
    //  if (this.index >= 11) {
    //    this.index = 1;
    //  }
    // }, 4000);
  },
  methods: {
    vdivmouseover(i) {
      this.mouseIndex = i;
    },
    vdivmouseout() {
      this.mouseIndex = 0;
    },
    toAbout() {
      this.$router.push({
        name: 'About1',
      });
    }
  },
  mounted() {
    this.$store.commit('setMenuId', 'home');
  }
};
</script>

<style lang="less" module>
.home {
  min-width: 1280px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  -webkit-touch-callout:none; /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none;
}

.box {
  width: 100%;
  margin: 0 auto;
}

.wentiSpan {
  width: 355px;
  height: 37px;
  font-size: 48px;
  font-family: Arial;
  font-weight: bold;
  color: #EBEBEB;
  line-height: 20px;
  opacity: 0.18;
}

.wentiSpan1 {
  width: 150px;
  height: 28px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 30px;
}

.p1_1 {
  width:130px;
  height: 146px;
  margin-left: 79px;
  position: relative;
}

.p1_2 {
  width: 60px;
  height: 18px;
  font-size: 24px;
  font-family: Arial;
  font-weight: bold;
  color: #005BAC;
  line-height: 30px;
  position:absolute;
  top:118px;
  left: 36px;
}

.p1_3 {
  width:259px;
  height:17px;
  margin: 6px auto;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #111111;
  line-height: 30px;
}

.p1_4 {
  width:259px;
  height:63px;
  margin: 14px auto;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
}

.p1_5 {
  width:288px;
  height:170px;
  margin: 43px auto;
  background: #F2F4F8;
  border-left: 3px solid #A9CAF9;
  position: relative;
}

.p1_6 {
  width:121px;
  height:16px;
  position: absolute;
  top:10px;
  left:27px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #111111;
  line-height: 30px;
}
.p1_7 {
  width:46px;
  height:1px;
  position: absolute;
  top:46px;left:27px;
  background: #004F95;
}
.p1_8 {
  width:288px;
  height:16px;
  position: absolute;
  top:67px;
  left:24px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.mp4{
  position:absolute;
  top:144px;
  left:0px;
  width:1122px;
  height:668px;
}
.mp{
  position:absolute;
  top:144px;
  left:0px;
  width:1122px;
  height:668px;
  z-index: 9999999;
  background: url(../assets/img/home/水印.png) no-repeat;
}

.img1{
  position:absolute;
  top:144px;
  left:0px;
  width:1122px;
  height:668px;
  background: url(../assets/img/home/eDVS2-无框.png) no-repeat;
}

.info1{
  position:absolute;
  top:7px;
  left:16px;
  width: 340px;
  font-size: 16px;
  height:74px;
  line-height: 25px;
  margin-top:10px;
  background: url(../assets/img/home/对话框左1.png) no-repeat;
}

.info2{
  position:absolute;
  top:168px;
  left:16px;
  width: 260px;
  height:106px;
  font-size: 16px;
  line-height: 25px;
  margin-top:10px;
  background: url(../assets/img/home/对话框左2.png) no-repeat;
}

.info3{
  position:absolute;
  top:348px;
  left:16px;
  width: 260px;
  height:86px;
  font-size: 16px;
  line-height: 25px;
  margin-top:10px;
  background: url(../assets/img/home/对话框左3.png) no-repeat;
}

.info4{
  position:absolute;
  top:485px;
  left:16px;
  width: 250px;
  height:86px;
  font-size: 16px;
  line-height: 25px;
  margin-top:10px;
  background: url(../assets/img/home/对话框左4.png) no-repeat;
}

.info5{
  position:absolute;
  top:6px;
  left:550px;
  width: 268px;
  height:146px;
  font-size: 16px;
  line-height: 25px;
  margin-top:10px;
  background: url(../assets/img/home/对话框中1.png) no-repeat;
}

.info6{
  position:absolute;
  top:6px;
  left:895px;
  width: 215px;
  height:130px;
  font-size: 16px;
  line-height: 25px;
  margin-top:10px;
  background: url(../assets/img/home/对话框右1.png) no-repeat;
}

.info7{
  position:absolute;
  top:206px;
  left:935px;
  width: 180px;
  height:120px;
  font-size: 16px;
  line-height: 25px;
  margin-top:10px;
  background: url(../assets/img/home/对话框右2.png) no-repeat;
}
.info8{
  position:absolute;
  top:360px;
  left:800px;
  width: 315px;
  height:88px;
  font-size: 16px;
  line-height: 25px;
  padding-top:50px;
  background: url(../assets/img/home/对话框右3.png) no-repeat;
}
.info9{
  position:absolute;
  top:500px;
  left:750px;
  width: 362px;
  height:60px;
  font-size: 16px;
  line-height: 25px;
  padding-top:10px;
  background:url(../assets/img/home/对话框右4.png) no-repeat;
}
.info10{
  position:absolute;
  top:585px;
  left:660px;
  width: 452px;
  height:65px;
  font-size: 16px;
  line-height: 25px;
  padding-top:10px;
  background:url(../assets/img/home/对话框右5.png) no-repeat;
}

.mask1{
  position:absolute;
  top:20px;
  left:320px;
  width: 170px;
  font-size: 16px;
  height:150px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask2{
  position:absolute;
  top:100px;
  left:195px;
  width: 110px;
  font-size: 16px;
  height:120px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask3{
  position:absolute;
  top:245px;
  left:285px;
  width: 95px;
  font-size: 16px;
  height:200px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask4{
  position:absolute;
  top:455px;
  left:245px;
  width: 135px;
  font-size: 16px;
  height:180px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask5{
  position:absolute;
  top:85px;
  left:555px;
  width: 185px;
  font-size: 16px;
  height:120px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask6{
  position:absolute;
  top:50px;
  left:855px;
  width: 125px;
  font-size: 16px;
  height:105px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask7{
  position:absolute;
  top:150px;
  left:785px;
  width: 125px;
  font-size: 16px;
  height:105px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask8{
  position:absolute;
  top:256px;
  left:785px;
  width: 165px;
  font-size: 16px;
  height:135px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask9{
  position:absolute;
  top:386px;
  left:655px;
  width: 125px;
  font-size: 16px;
  height:155px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.mask10{
  position:absolute;
  top:476px;
  left:415px;
  width: 220px;
  font-size: 16px;
  height:155px;
  line-height: 25px;
  margin-top:10px;
  cursor: pointer;
  background: rgba(255,255,255,0);
}
.threesolid{
  font-size: 30px;
  color:#fefefe;
  text-shadow:0px 1px 0px #c0c0c0,
   0px 2px 0px #b0b0b0,
   0px 3px 0px #a0a0a0,
   0px 4px 0px #909090,
   0px 5px 10px rgba(0, 0, 0, .9);
}
.flow {
  height: 120px;
  width:150px;
  background: linear-gradient(to right, red, orange, yellow, green, cyan, blue,  purple);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation:  hue 1s linear infinite;
}
@keyframes hue {
    0% {
        filter: hue-rotate(0deg);
    }
    100% {
        filter: hue-rotate(360deg);
    }
}
@keyframes blink {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 1;
        transform: scale(2);
      }
      100% {
        opacity: 0;
        transform: scale(1);
      }
    }
.blink {
      margin-top: 50rpx;
      font-size: 36rpx;
      color: #007AFF;
      animation: blink 3s infinite;
    }
.div{
  animation: twinkle 4s infinite alternate;
}
@keyframes twinkle {
  0%{
    opacity:0.2;
  }
  50%{
    opacity:0.8;
  }
  100%{
    opacity:0.2;
  }
}
.div1{
  opacity:0.2;
}
.div2{
  opacity:0.8;
}
</style>
